import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { showAlertModal } from '../../../../actions';
import { formatDisplayTS } from '../../../common/Utilities';
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';
import ConfigForm from '../config/ConfigForm';

class DeviceForm extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      bID: '',
      name: '',
      customerId: '',
      customerName: '',
      filteredProjects: [],
      projectId: '',
      projectName: '',
      config: {},
      deviceEdit: false,
      showConfirmSave: false,
      reloadConfig: false,
    }
  }

  componentDidMount(){
    if(this.props.device){
      // we are editing a current device
      this.setState({
        bID: this.props.device.bID,
        name: this.props.device.sName,
        customerId: this.props.device.bCustomerID,
        customerName: this.props.device.sCustomerName,
        filteredProjects: this.props.sites.filter(p => p.bCustomerID === parseInt(this.props.device.bCustomerID)),
        projectId: this.props.device.bCustomerProjectID,
        projectName: this.props.device.sProjectName,
        config: this.props.device.sConfig ? JSON.parse(JSON.stringify(this.props.device.sConfig)) : [],
        deviceEdit: true,
        showConfirmSave: false,
        reloadConfig: false,
      })
    }
  }

  componentDidUpdate() {
    if(this.props.device && this.props.device.bID && this.props.device.bID !== this.state.bID){
      this.setState({
        bID: this.props.device.bID,
        name: this.props.device.sName,
        customerId: this.props.device.bCustomerID,
        customerName: this.props.device.sCustomerName,
        filteredProjects: this.props.sites.filter(p => p.bCustomerID === parseInt(this.props.device.bCustomerID)),
        projectId: this.props.device.bCustomerProjectID,
        projectName: this.props.device.sProjectName,
        config: {},
        deviceEdit: true,
        showConfirmSave: false,
        reloadConfig: true,
      })
    }
  }

  handleChange = (e, type) => {
    let value = e.target.value;
    this.setState({ [type]: value });

    if (type === 'customerId') {
      if (value === 'none') {
        // reset customerId and projectId
        this.setState({ customerName: 'None', projectId: 'none', projectName: 'None', filteredProjects: [] });
        return;
      };

      // filter out projects that match the selected customer
      let targetCustomer = this.props.customers.find(customer => customer.bID === parseInt(value));
      let targetProjects = this.props.sites.filter(p => p.bCustomerID === parseInt(value));

      if (targetProjects.length > 0) {
        this.setState({
          customerName: targetCustomer.sName,
          projectId: targetProjects[0].bID.toString(),
          projectName: targetProjects[0].sName.toString(),
          filteredProjects: targetProjects,
        })
      } else {
        this.setState({ customerName: 'None', projectId: 'none', projectName: 'None', filteredProjects: [] });
      }
      return;
    }

    if (type === 'projectId') {
      if (value === 'none') {
        this.setState({ projectName: 'None' });
        return;
      };

      let targetProject = this.props.sites.find(c => c.bID === parseInt(value));
      if (targetProject) {
        this.setState({ projectName: targetProject.sName });
      } else {
        this.setState({ projectName: 'None' });
      };
      return;
    };
  }

  handleConfigChanges = (type, value) => {
    this.setState({[type]: value})
  }

  handleConfigReload = () => {
    this.setState({config: JSON.parse(JSON.stringify(this.props.device.sConfig))})
  }

  onSubmit = async() => {
    if(this.state.name.trim() === '' || parseInt(this.state.projectId) === 0 || this.state.projectId === 'none' ) {
      this.props.showAlertModal(['WARNING', 'Device name and site must be provided. Please revise.'])
      return;
    };

    // not all devices have config data, only check if there are empty config fields if they had one in the first place
    const emptyConfigs = Object.keys(this.state.config).length
      ? Object.entries(this.state.config).find(([_, fields]) => Object.entries(fields).find(([_, value]) => value === '')) : false
    if (emptyConfigs) {
      this.props.showAlertModal(['WARNING', 'All device configs are required. Please revise.'])
      return
    }

    this.setState({showConfirmSave: true})
  }

  onSave = async () => {
    this.setState({showConfirmSave: false})
    const reqBody = {
      "id": this.props.device.bID,
      "name": this.state.name,
      "customerId": parseInt(this.state.customerId),
      "projectId": parseInt(this.state.projectId),
      "deviceId": this.props.device.sDeviceID,
      "config": this.state.config,
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + 've/device?device=' + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'Device details successfully saved.'])
      this.props.updateData('device', {
        bID: this.props.device.bID,
        sName: this.state.name,
        bCustomerID: parseInt(this.state.customerId),
        sCustomerName: this.state.customerName,
        bCustomerProjectID: parseInt(this.state.projectId),
        sProjectName: this.state.projectName,
        sConfig: this.state.config,
      })
      this.setState({reloadConfig: true})

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to save device details.'])
    })
  }

  cancelSave = () => {
    document.getElementById('form-wrapper').focus()
    this.setState({showConfirmSave: false})
  }

  undoEdit = () => {
    this.setState({
      bID: this.props.device.bID,
      name: this.props.device.sName,
      customerId: this.props.device.bCustomerID,
      customerName: this.props.device.sCustomerName,
      filteredProjects: this.props.sites.filter(p => p.bCustomerID === parseInt(this.props.device.bCustomerID)),
      projectId: this.props.device.bCustomerProjectID,
      projectName: this.props.device.sProjectName,
      deviceEdit: true,
      showConfirmSave: false,

      // this is for handling config change
      // JS does not detect multi-level object changes, so we have to explicitly change the object (in our case, we emptied it out) then update it later with the new value
      // so React can say that {} != {some object content} and re-render
      config: {},
      reloadConfig: true,
    });
  }

  onBlur = (e) => {
    if (this.props.device) {
      if ((this.state.name !== this.props.device.sName)
        || (parseInt(this.state.customerId) !== parseInt(this.props.device.bCustomerID))
        || (parseInt(this.state.projectId) !== parseInt(this.props.device.bCustomerProjectID))
        || (JSON.stringify(this.state.config) !== JSON.stringify(this.props.device.sConfig))) {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    const styles = {
      row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginLeft: this.state.deviceEdit ? '1vmin' : '4vmin',
        marginBottom: '1.6vmin',
        marginRight: this.state.deviceEdit ? '1vmin' : 0,
      },
      label: {
        margin: 0,
        fontSize: '1.6vmin',
        width: '50%'
      },
      inputText: {
        fontSize: '1.6vmin',
        width: '50%'
      },
      inputSelect: {
        fontSize: '1.6vmin',
        width: '52%'
      },
    }

    const confirmMessage = (
      <div>
        <p>Are you sure you want to save the changes?</p>
        <p>Note that this cannot be undone and changes you made will update the device and all its related components (cameras/views).</p>
        <p style={{fontWeight: 'bold'}}>Would you like to proceed?</p>
      </div>
    )

    return (
      <FormWrapper
        heading={this.state.deviceEdit ? "Edit Device" : "New Device"}
        onBlur={this.onBlur}
        closeForm={this.props.closeForm}
        onSubmit={this.onSubmit}
        edit={this.state.deviceEdit}
        undoEdit={this.undoEdit} >

        <div style={{ width: '100%' }}>
          <div style={styles.row}>
            <p style={styles.label}>Name:</p>
            <input
              name="name"
              type="text"
              value={this.state.name}
              style={styles.inputText}
              onChange={(e) => this.handleChange(e, 'name')} />
          </div>

          { this.props.device &&
              <div style={styles.row}>
                <p style={styles.label}>Device ID:</p>
                <input
                  name="name"
                  type="text"
                  value={this.props.device.sDeviceID}
                  style={styles.inputText}
                  disabled />
              </div>
          }

          {/* if customer changes only allow projects for that customer to be selected as sites */}
          <div style={styles.row}>
            <p style={styles.label}>Customer:</p>
            <select value={this.state.customerId} onChange={e => this.handleChange(e, 'customerId')} style={styles.inputSelect}>
              <option value={'none'}>None</option>
              {this.props.customers.map( c => (
                  <option key={c.bID} value={c.bID}>{c.sName}</option>
                ))
              }
            </select>
          </div>

           {/* if site changes - customer should also change to reflect that projects predefined customer  */}
           <div style={styles.row}>
            <p style={styles.label}>Site:</p>
            <select value={this.state.projectId} onChange={e => this.handleChange(e, 'projectId')} style={styles.inputSelect}>
              <option value={'none'}>None</option>
              {this.state.filteredProjects.map( c => (
                  <option key={c.bID} value={c.bID}>{c.sName}</option>
                ))
              }
            </select>
          </div>

          <div style={styles.row}>
            <p style={styles.label}>IP Address:</p>
            <input
              name="ip"
              type="text"
              disabled
              value={this.props.device.sCurrentIP}
              style={styles.inputText} />
          </div>

          { this.props.device &&
            <div style={styles.row}>
              <p style={styles.label}>Backend ID:</p>
              <input
                name="backendId"
                type="text"
                value={this.props.device.sBackendID !== '' ? this.props.device.sBackendID : 'NULL'}
                disabled
                style={styles.inputText} />
            </div>
          }

          { this.props.device &&
            <div style={styles.row}>
              <p style={styles.label}>Last Event TS:</p>
              <input
                name="lastEventTS"
                type="text"
                value={this.props.device.convertedTS ? formatDisplayTS(this.props.device.convertedTS, true) : (this.props.device.sLastEventTS ? formatDisplayTS(this.props.device.sLastEventTS, false) : '')}
                disabled
                style={styles.inputText} />
            </div>
          }

          <div style={styles.row}>
            <p style={styles.label}>Camera Count:</p>
            <input
              name="cameraCount"
              type="text"
              value={this.props.device.bCameras}
              disabled={ this.props.device ? true : false }
              style={styles.inputText} />
          </div>
        </div>

        <ConfigForm
          deviceId={this.props.device.sDeviceID}
          config={this.state.config}
          reloadConfig={this.state.reloadConfig}
          handleConfigChanges={this.handleConfigChanges}
          handleConfigReload={this.handleConfigReload} />

        {this.state.showConfirmSave &&
          <Dialog
            overlayStyle = {{zIndex: 1000}}
            title = "WARNING"
            content = {confirmMessage}
            buttons={[
              {label: 'Yes', onClick: this.onSave},
              {label: 'Cancel', onClick: this.cancelSave}
            ]}
          />
        }
      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
export default connect(mapStateToProps, { showAlertModal } )(DeviceForm);